'use client';

import { useEffect } from 'react';
import { create } from 'zustand';

import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';

const useSupportHoursStore = create<{ hours: string | undefined }>(() => ({ hours: undefined }));

/**
 * The dialog opens from anywhere on the client, but the opening hours are an administration text
 * that only the server reads: the header hands them over once per page.
 */
export function SupportHoursHydrator({ hours }: { hours?: string }) {
  useEffect(() => {
    useSupportHoursStore.setState({ hours });
  }, [hours]);

  return null;
}

/** Phone and opening hours of the customer line, as the footer shows them (password-reset step 1). */
export function useSupportContact() {
  const phone = useGlobalStore(state => state.generalLayout.contact?.phone) || undefined;
  const hours = useSupportHoursStore(state => state.hours);

  return { supportPhone: phone, supportHours: hours };
}
